<div class="map-container">
    <div class="map-frame">
        <div id="map"></div>
    </div>
</div>
<div [hidden]="true"> <!-- is bound to every city popup -->
    <app-converter-view id="converter">

    </app-converter-view>

</div>